<template>
    <div class="case">
        <banner img="bgtop.jpg" title="精典案例"/>
        <div class="case-section" v-loading="loading">
            <div class="case-section-content">
                <div class="case-section-content-list" v-for="(cas,index) in caseList" :key="index">
                    <img v-lazy="imgserver+cas.Img"/>
                    <div class="content-list-abstract" :class="{'abstract-active' : index%2!=1}">
                        <p class="abstract-title">{{ cas.Title }}</p>
                        <p class="abstract-content">{{ cas.Content }}</p>
                        <div class="more">
                            <router-link
                                class="text-decoration"
                                :to="{ name: 'casedetails', params: { id: cas.Id }}"
                            >
                                <span>详情</span>
                                <img :src="getImagePath('sanjiao.png')"/>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Banner from "../components/Banner";

export default {
    components: {
        Banner
    },
    data() {
        return {
            loading: true,
            caseList: []
        };
    },
    mounted() {
        window.console.log("case");
        this.$http
            .get("Cases/GetCasesAll")
            .then(response => {
                //console.log(response);
                this.caseList = response.data.data;
                //window.console.log(this.caseList);
                this.loading = false;
            })
            .catch(function (error) {
                window.console.log(error);
            });
    }
};
</script>

<style lang="scss" scoped>
.case {
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
    //background-color: #14679f;

    &-section {
        width: 100%;

        &-content {
            width: 1240px;
            min-height: 1000px;
            margin: 0 auto;
            background-color: #fff;

            &-list {
                width: 100%;
                height: 500px;
                display: flex;
                justify-content: center;
                align-items: center;
                border-bottom: 1px solid pink;
                //border: 1px solid pink;

                img {
                    width: 612px;
                    height: 400px;
                }

                .content-list-abstract {
                    width: 290px;
                    height: 350px;
                    padding: 0 20px;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-around;

                    .abstract-title {
                        line-height: 30px;
                        font-size: 22px;
                        color: #e13834;
                    }

                    .abstract-content {
                        height: 150px;
                        color: #484848;
                        font-size: 15px;

                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 7;
                        -webkit-box-orient: vertical;
                        white-space: normal !important;
                        word-wrap: break-word;
                        //border: 1px solid pink;
                    }

                    .more {
                        display: flex;
                        justify-content: flex-start;

                        .text-decoration {
                            text-decoration: none;

                            span {
                                color: #000;
                            }

                            img {
                                width: 12px;
                                height: 12px;
                            }
                        }
                    }
                }

                .abstract-active {
                    order: -1;
                }
            }
        }
    }
}

@media (max-width: 1280px) {
    .case-section-content {
        width: 100%;
        padding: 0 20px;
        box-sizing: border-box;
        min-height: 0;

        &-list {
            img {
                width: auto;
                max-width: 612px;
                height: auto;
                flex: 1 1 auto;
                min-width: 0;
            }

            .content-list-abstract {
                flex-shrink: 0;
                box-sizing: border-box;
            }
        }
    }
}

@media (max-width: 768px) {
    .case-section-content {
        padding: 0 12px;

        &-list {
            height: auto;
            flex-direction: column;
            padding: 20px 0;
            box-sizing: border-box;

            img {
                width: 100%;
                height: auto;
            }

            .content-list-abstract {
                width: 100%;
                height: auto;
                padding: 15px 0;
                box-sizing: border-box;

                .abstract-content {
                    height: auto;
                }
            }
        }
    }
}
</style>